import { type MylensesCommunityAudiencePageView } from "@snapchat/blizzard-schema";

export interface CommunityAudiencePageEventData {
    event: MylensesCommunityAudiencePageView["event_name"];
}

export const createCommunityAudiencePageEvent = (
    { event }: CommunityAudiencePageEventData,
    sessionId: string,
): MylensesCommunityAudiencePageView => ({
    event_name: event,
    mylenses_session_id: sessionId,
});
